module.exports = __webpack_public_path__ + "fonts/Gotham-Bold.dc72ea54.woff";